import Vue from 'vue'

import uiInput from './src/ui-input.vue';

Vue.component('ui-input', uiInput);

export default uiInput;



//////////////////
// WEBPACK FOOTER
// ./~/ui-input/index.js
// module id = 550
// module chunks = 0